import AuthorizationModal from "../../../generator/_Modals/AuthorizationModal/AuthorizationModal";
import { useGetApi, usePostApi } from "../../../hooks";
import useLoginUser from "../../shared/Login/useLoginUser";
import { Fragment, useState } from "react";
import RotationModal from "../../shared/Login/RotationModal";
import { IRotationModalProps } from "../../shared/Login/login.model";
import { getYachtId } from "../../../utils";
import { ICredentials } from "../../../interfaces";

interface Props {
  opened: boolean;
  close: () => void;
}

export const usersMapper = (data: any) => {
  if (!data?.list || !Array.isArray(data.list)) return [];
  return data.list.map((user: any) => ({
    label: `${user.rolename} ${user.full_name}`,
    value: user.email,
    email: user.email,
  }));
};

const LoginModal = ({ opened, close }: Props) => {
  const [rotationModalProps, setRotationModalProps] =
    useState<IRotationModalProps>();

  const { handleLogin, isLoading } = useLoginUser({ setRotationModalProps });
  const { data: users } = useGetApi({
    request: "get-users-full",
    body: {
      params: {
        yachtid: getYachtId(),
      },
    },
    mapper: usersMapper,
    fetchOnInit: opened,
  });

  const handleAuthorizeGenericLogin = async (data: ICredentials) => {
    const params = {
      pass: data.pass,
      email: data.userid,
    };
    await handleLogin(params);
    location.reload();
  };

  return (
    <Fragment>
      <RotationModal
        {...rotationModalProps}
        onYes={d => handleAuthorizeGenericLogin(d)}
        close={() => setRotationModalProps({ open: false })}
      />
      <AuthorizationModal
        opened={opened}
        close={close}
        loading={isLoading}
        onSubmit={handleAuthorizeGenericLogin}
        users={users}
        title="Log in to authorized account"
        passOnly
      />
    </Fragment>
  );
};
export default LoginModal;
